import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import profile from '../data/profile';

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-left">
          <img src="images/logo.png" alt="Logo" className="brand-logo brand-logo--footer" />
          <p>
            © {year} {profile.name}. {t('footer.rights')}
          </p>
        </div>

        <ul className="footer-social">
          <li>
            <a
              href="https://www.linkedin.com/in/murat-s-960b5a230/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="clickable"
            >
              <FaLinkedin />
            </a>
          </li>
          <li>
            <a
              href="https://github.com/MuratSelcukoglu"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="clickable"
            >
              <FaGithub />
            </a>
          </li>
          <li>
            <a
              href={`mailto:${profile.email}`}
              aria-label="Email"
              className="clickable"
            >
              <FaEnvelope />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
